<template>
    <!-- Una columna por representante: nombre, cargo y correo, una línea cada
         uno. Si no hay ninguno no se pinta nada. -->
    <v-row v-if="representantes.length" class="mx-3">
        <v-col
            v-for="representante in representantes"
            :key="representante.id"
            class="text-center"
        >
            <h4>{{ representante.nombre }}</h4>
            <div>{{ representante.cargo_completo }}</div>
            <a :href="`mailto:${representante.correo}`">{{ representante.correo }}</a>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";

// Los contactos del sistema de prácticas, leídos de /api/representantes/. Va
// sin token: lo usan páginas públicas que se abren sin sesión. Los jefes de
// carrera que todavía nadie completa no se muestran.
export default {
    name: "ContactosRepresentantes",

    data: () => ({
        representantes: [],
    }),

    created() {
        axios
            .get(`${process.env.VUE_APP_API_URL}/representantes/`)
            .then((response) => {
                this.representantes = response.data.filter(
                    (representante) => representante.nombre && representante.correo
                );
            });
    },
};
</script>
